import Router from 'next/router';
import { Amplify } from 'aws-amplify';
let localStorageKey = 'reckon:access-token';

export function configureAmplifyAuth(clientId: string) {
  const webClients = (process.env.userPoolWebClientIds as unknown) as {
    [key: string]: any;
  };
  const { identityPoolId, userPoolId, oauthDomain, useCookieStorage } =
    webClients[clientId] || {};

  const authConfig = {
    Auth: {
      identityPoolId: identityPoolId || process.env.identityPoolId,
      region: process.env.region,
      userPoolId: userPoolId || process.env.userPoolId,
      userPoolWebClientId: clientId,
      oauth: {
        domain: oauthDomain || process.env.oauthDomain,
        scope: process.env.oauthScope,
        redirectSignIn: process.env.oauthRedirectSignIn,
        redirectSignOut: process.env.oauthRedirectSignOut,
        responseType: process.env.oauthResponseType,
      },
      ...(useCookieStorage
        ? {
            cookieStorage: process.env.cookieStorage,
          }
        : {}),
    },
  };
  Amplify.configure(authConfig);
}

export function configureAPSAuth() {
  const apsCognitoConfig =
    ((process.env.apsCognito as unknown) as {
      [key: string]: string;
    }) || {};
  const authConfig = {
    Auth: {
      identityPoolId: apsCognitoConfig.identityPoolId,
      region: process.env.region,
      userPoolId: apsCognitoConfig.userPoolId,
      userPoolWebClientId: apsCognitoConfig.clientId,
      oauth: {
        domain: apsCognitoConfig.oauthDomain,
        scope: process.env.oauthScope,
        redirectSignIn: process.env.oauthRedirectSignIn,
        redirectSignOut: process.env.oauthRedirectSignOut,
        responseType: process.env.oauthResponseType,
      },
    },
  };
  Amplify.configure(authConfig);
}

export function getCredentials(): {
  token?: string;
  refreshToken?: string;
  mfaToken?: string;
} {
  try {
    return typeof window !== 'undefined'
      ? JSON.parse(localStorage.getItem(localStorageKey)!) || {}
      : {};
  } catch (err) {
    return {};
  }
}

export function setCredentials(creds: {
  token?: string;
  refreshToken?: string;
  mfaToken?: string;
}) {
  if (typeof window !== 'undefined')
    localStorage.setItem(localStorageKey, JSON.stringify(creds));
}

export function clearCredentials() {
  if (typeof window !== 'undefined') localStorage.removeItem(localStorageKey);
}

export const logout = () => {
  clearCredentials();
  Router.push('/login');
};
